import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BsCalendar2 } from 'react-icons/bs';
import { RiUserHeartLine } from 'react-icons/ri';
import { useNavigate } from 'react-router';

import { Button, StickyFooter } from '@/components';

const ProfileStickyFooter: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleProfileSettingsClick = () => {
    void navigate('/profile/settings');
  };

  const handleBookNowClick = () => {
    void navigate('/booking');
  };

  return (
    <StickyFooter className="bg-white/90 shadow-none! backdrop-blur">
      <div className="flex w-full gap-2">
        <Button
          type="button"
          variant="primary"
          size="md"
          className="h-12 w-auto flex-1 gap-2 text-base leading-5 font-normal!"
          onClick={handleProfileSettingsClick}
        >
          <RiUserHeartLine className="size-4" />
          <span>{t('profile.home.actions.profileSettings')}</span>
        </Button>

        <Button
          type="button"
          variant="outline"
          size="md"
          className="hover:border-border-hover h-12 w-auto flex-1 gap-2 border-none font-normal! text-black"
          onClick={handleBookNowClick}
        >
          <BsCalendar2 className="text-text-muted size-4" />
          <span>{t('profile.home.actions.bookNow')}</span>
        </Button>
      </div>
    </StickyFooter>
  );
};

export default ProfileStickyFooter;
